import {
  PackageDetail,
  PlanPayload,
  CalculateResponse,
  ApplyCouponResponse,
  CouponInfoResponse,
  PlanBuildResponse,
  UseCases,
  LoginUrlResponse,
} from './interfaces';
import { usePost, useFetch } from '@selfserve/react-hooks';

import { apiEndpoints } from '@selfserve/react-utils';

export const usePackageDetailRequest = (hash: string) => {
  const url = apiEndpoints.packageDetail.replace(':hash', hash);
  return useFetch<PackageDetail>(url);
};

export const useGetLoginUrlRequest = (subscriptionId: string) => {
  const url = apiEndpoints.loginUrl.replace(':id', subscriptionId);

  return useFetch<LoginUrlResponse>(url, undefined, {
    enabled: !!(url && subscriptionId),
  });
};

export const useGetLoginFormRequest = (url: string) => {
  return usePost<any, string>(url);
};

export const useCalculateSummaryRequest = (hash?: string) =>
  usePost<PlanPayload, CalculateResponse>(
    apiEndpoints.calculateSummary.replace(':hash', hash || '')
  );

export const useCalculateSummaryBySubscriptionIdRequest = (
  subscriptionId?: string
) =>
  usePost<PlanPayload, CalculateResponse>(
    apiEndpoints.calculateSummaryBySubscriptionId.replace(
      ':subscriptionId',
      subscriptionId || ''
    )
  );

export const useBuildPlanRequest = (hash: string) =>
  usePost<PlanPayload, PlanBuildResponse>(
    apiEndpoints.buildPlan.replace(':hash', hash)
  );

export const useApplyCouponRequest = (planId: string, couponId: string) =>
  usePost<any, ApplyCouponResponse>(
    apiEndpoints.applyCoupon
      .replace(':planId', planId)
      .replace(':couponId', couponId)
  );

export const useRemoveCouponRequest = (planId: string, couponId: string) =>
  usePost<any, any>(
    apiEndpoints.removeCoupon
      .replace(':planId', planId)
      .replace(':couponId', couponId)
  );

export const useCouponInfoRequest = (couponId: string, enabled: boolean) =>
  useFetch<CouponInfoResponse>(
    apiEndpoints.couponInfo.replace(':couponId', couponId),
    undefined,
    { enabled }
  );

export const useLoginPage = (url: string, enabled: boolean) =>
  useFetch<any>(url, undefined, { enabled });

export const useEmailValidation = (id: string) =>
  useFetch<any>(apiEndpoints.emailValidationById.replace(':id', id));

export const useUseCaseRequest = (id = '') =>
  useFetch<UseCases>(apiEndpoints.useCases.replace(':id', id), undefined, {
    enabled: !!id,
  });

export const useUseCaseSelect = (id = '') =>
  usePost<UseCases, UseCases>(apiEndpoints.setUseCases.replace(':id', id));

export * from './interfaces';
export * from './schemas';
